import { Box, Card, Collapse, Group, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Icons } from '../Shares/Icons';
import classes from './VipClub.module.css';
export type VipClubQuestionCardProps = {
  title: string;
  content: string;
};
export const VipClubQuestionCard: React.FC<VipClubQuestionCardProps> = ({
  title,
  content
}) => {
  const [active, {
    toggle
  }] = useDisclosure(false);
  return <Box w="100%" mx="auto">
      <Card withBorder onClick={toggle} bg="transparent" mod={{
      active: active
    }} p={{
      base: 16,
      sm: 20
    }} className={classes.collapse}>
        <Group justify="space-between" gap={10}>
          <Text maw="85%" fz={13} tt="uppercase" fw={700}>
            {title}
          </Text>
          <Box component="span" style={{
          rotate: active ? '180deg' : '',
          transition: 'rotate .3s ease'
        }}>
            <Icons className="icon-pr-line-chevron-down" fontSize={24} />
          </Box>
        </Group>
      </Card>

      <Collapse mt={16} in={active}>
        <Text maw={{
        lg: 742
      }} fz="xs" mx={20} c="var(--text-white)">
          {content}
        </Text>
      </Collapse>
    </Box>;
};